import { render } from "./Header.vue?vue&type=template&id=20e815e4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=20e815e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20e815e4"

export default script